export class FileHelper {
    static cleanFileName(fileName: string): string {
        let cleanName = fileName.toLowerCase();

        cleanName = cleanName
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s.-]/g, '');

        cleanName = cleanName.replace(/\s+/g, '-');

        cleanName = cleanName.replace(/-+/g, '-').slice(0, 255);

        cleanName = cleanName.replace(/^-+|-+$/g, '');

        if (!cleanName) {
            cleanName = 'fichier-sans-nom';
        }

        return cleanName;
    }

    static handleFileUpload(file: File): File {
        const cleanName = FileHelper.cleanFileName(file.name);

        return new File([file], cleanName, {
            type: file.type,
            lastModified: file.lastModified,
        });
    }
}
